import { render, staticRenderFns } from "./TableRiskAppraisal592.vue?vue&type=template&id=75b42cb3&scoped=true"
import script from "./TableRiskAppraisal592.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal592.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal592.vue?vue&type=style&index=0&id=75b42cb3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b42cb3",
  null
  
)

export default component.exports